import { render, staticRenderFns } from "./popupadvertising.vue?vue&type=template&id=3ee7a134&scoped=true"
import script from "./popupadvertising.vue?vue&type=script&lang=ts"
export * from "./popupadvertising.vue?vue&type=script&lang=ts"
import style0 from "./popupadvertising.vue?vue&type=style&index=0&id=3ee7a134&prod&lang=less&scoped=true"
import style1 from "./popupadvertising.vue?vue&type=style&index=1&id=3ee7a134&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7a134",
  null
  
)

export default component.exports